/**
 * report-search — the URL state of the Reports section's hours reports. Every filter
 * lives in the URL, so a link reproduces the view on the weekly staffing call, and the
 * server is re-queried on every change (spec S4.1.1). Only non-default values are kept.
 */

const MONTH = /^\d{4}-(0[1-9]|1[0-2])$/;

const month = (v: unknown) => (typeof v === "string" && MONTH.test(v) ? v : undefined);
function oneOf<T extends string>(values: readonly T[], v: unknown): T | undefined {
  return values.find((x) => x === v);
}

export interface RangeSearch {
  from?: string | undefined;
  to?: string | undefined;
}

export interface DemandSearch extends RangeSearch {
  /** "include" adds internal (non-billable) Demands. */
  internal?: "include" | undefined;
}

export function decodeRangeSearch(search: Record<string, unknown>): RangeSearch {
  return { from: month(search.from), to: month(search.to) };
}

export function decodeDemandSearch(search: Record<string, unknown>): DemandSearch {
  return { ...decodeRangeSearch(search), internal: oneOf(["include"] as const, search.internal) };
}

/** URL state → the API's query parameters (src/schemas/hours-reports.ts). */
export function demandApiParams(s: DemandSearch): Record<string, string | undefined> {
  return {
    from: s.from,
    to: s.to,
    includeInternal: s.internal === "include" ? "true" : undefined,
  };
}
